export const getPortalFoodTypes = (API, request, callback) => {
    API.get(`foodtypes`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}
